import { ISerologyTracking } from '@nkr/models/index';
import { Actions } from './models';
import { SerologyListType } from '@nkr/store/index';
import OverlayMenuButton from '@nkr/components/overlay-menu-button';

interface IProps {
    centerId: number,
    data: ISerologyTracking,
    listType: SerologyListType,
    showActions: boolean,
    showBsMenu: boolean,
    onMenuDisplayed?: (id: number) => void,
    onMenuToggle: (show: boolean) => void,
    onItemSelected: (data: ISerologyTracking, action: number) => void
}

const menuItemList = [
    { action: Actions.MarkReceived, title: <>Mark Received</> },
    { action: Actions.MarkRemoteShipped, title: <>Ship to Remote Donor</> },
    { action: Actions.MarkShippedBack, title: <>Serology Tests Shipped Back</> },
    { action: Actions.TrackPackage, title: <>Track Package</> },
];

const ActionsDropdown = (props: IProps) => {
    const handleMenuToggle = (show: boolean) => {
        props.onMenuToggle(show);
    };

    const handleMenuSelection = (id: any, action: number) => {
        props.onItemSelected(props.data, action);
    };

    const getUrl = (action: Actions) => {
        // let { serologyTracking } = props;
        let { remoteSendTrackingNumber, shipBackTrackingNumber, shipOutTrackingNumber, status } = props.data;

        switch (action) {
            case Actions.TrackPackage: return {
                link: "https://www.packagetrackr.com/track/" + (status == "Vendor Kit Shipped" ? shipOutTrackingNumber :
                    status == "Shipped to Remote Donor" ? remoteSendTrackingNumber :
                        shipBackTrackingNumber), target: '_blank'
            };
        }
    };

    const getMenuItems = () => {
        let menuItems: Actions[] = [];

        let showMarkedReceived = props.data.showMarkedReceived;
        let showShippedToRemoteDonor = props.data.showShippedToRemoteDonor;
        let showSerologyTestsShippedBack = props.data.showSerologyTestsShippedBack;
        let showSerologyTracking = props.data.showSerologyTracking;

        if (showMarkedReceived) {
            menuItems.push(Actions.MarkReceived);
        }

        if (showShippedToRemoteDonor) {
            menuItems.push(Actions.MarkRemoteShipped);
        }

        if (showSerologyTestsShippedBack) {
            menuItems.push(Actions.MarkShippedBack);
        }

        if (showSerologyTracking) {
            menuItems.push(Actions.TrackPackage);
        }

        return menuItems;
    };

    if (props.data == null)
        return null;

    const menuItems = getMenuItems().map(item => {
        return menuItemList.find(x => x.action == item);
    });

    const menu = menuItems.map(item => {
        let url = getUrl(item.action);
        let id = item.action >= 0 ? props.data.id : 'div-' + props.data.id + '-' + Math.random() * 10000;

        if (url == null) {
            return { id, action: item.action, include: true, selectable: true, element: <>{item.title}</> };
        } else {
            return { id, action: item.action, include: true, selectable: false, element: <a href={url.link} target={url.target}>{item.title}</a> };
        }
    });

    return (
        <OverlayMenuButton
            menu={menu}
            bsStyle='primary'
            bsSize={props.showBsMenu ? 'sm' : 'xs'}
            title='Actions'
            listItemStyle={{ padding: '2px 10px', fontSize: 14 }}
            includeCaret={true}
            onToggle={handleMenuToggle}
            onSelect={handleMenuSelection}
        />
    );
}

export default ActionsDropdown;